export const FLAG_CONTENT_HUB_ENABLE_PAGE_DUPLICATION =
  'content-hub-enable-page-duplication';

export const FLAG_CONTENT_HUB_ENABLE_RECORDING_LAB =
  'content-hub-enable-recording-lab';

export const FLAG_CONTENT_HUB_ENABLE_SPEAKER_EDIT =
  'content-hub-enable-speaker-edit';

export const FLAG_CONTENT_HUB_ENABLE_UPGRADE_BANNER =
  'content-hub-enable-upgrade-banner';

export const FLAG_POST_EVENT_ENABLE_CREATOR_LAB_CONSOLIDATION =
  'post-event-enable-creator-lab-consolidation';

export const FLAG_DISABLE_SSO_NAME_EDIT = 'disable-sso-name-edit';

export const FLAG_ORG_TEAM_AUDIT_REPORT_DOWNLOAD = 'audit-report-download';

export const FLAG_RC_ANALYTICS_IFRAME = 'rc-analytics-iframe';

export const FLAG_SPACES = 'pre-event-organization-spaces';

export const FLAG_ENABLE_HLS_THUMBNAILS = 'post-event-enable-hls-thumbnails';
